import { createSlice } from '@reduxjs/toolkit';

interface InitialStateProps {
  request: {
    isLoading: boolean;
    error: string | null;
  };
  list: {
    isLoading: boolean;
    hits: any[] | null;
    total: number | null;
    error: string | null;
  };
  one: {
    isLoading: boolean;
    data: Record<string, any> | null;
    error: string | null;
  };
  categories: {
    isLoading: boolean;
    hits: Record<string, any> | null;
    error: string | null;
  };
  difficultyLevels: {
    isLoading: boolean;
    hits: Record<string, any> | null;
    error: string | null;
  };
  fields: {
    isLoading: boolean;
    hits: Record<string, any> | null;
    error: string | null;
  };
}

const initialState: InitialStateProps = {
  request: {
    isLoading: false,
    error: null,
  },
  list: {
    isLoading: false,
    hits: null,
    total: null,
    error: null,
  },
  one: {
    isLoading: false,
    data: null,
    error: null,
  },
  categories: {
    isLoading: false,
    hits: null,
    error: null,
  },
  difficultyLevels: {
    isLoading: false,
    hits: null,
    error: null,
  },
  fields: {
    isLoading: false,
    hits: null,
    error: null,
  },
};

export const { actions: questionActions, reducer: questionReducer } = createSlice({
  name: 'question',
  initialState,
  reducers: {
    //Request
    setQuestionRequestStart: (state) => {
      state.request = {
        isLoading: true,
        error: null,
      };
    },
    setQuestionRequestSuccess: (state) => {
      state.request = {
        isLoading: false,
        error: null,
      };
    },
    setQuestionRequestFailure: (state, { payload }) => {
      state.request = {
        isLoading: false,
        error: payload.message,
      };
    },
    setQuestionRequestDefault: (state) => {
      state.request = {
        isLoading: false,
        error: null,
      };
    },

    //List
    setQuestionListRequest: (state) => {
      state.list = {
        isLoading: true,
        hits: null,
        total: null,
        error: null,
      };
    },
    setQuestionListSuccess: (state, { payload }) => {
      state.list = {
        isLoading: false,
        hits: payload.hits,
        total: payload.total,
        error: null,
      };
    },
    setQuestionListFailure: (state, { payload }) => {
      state.list = {
        isLoading: false,
        hits: null,
        total: null,
        error: payload.message,
      };
    },
    setQuestionListDefault: (state) => {
      state.list = {
        isLoading: false,
        hits: null,
        total: null,
        error: null,
      };
    },

    //One
    setQuestionRequest: (state) => {
      state.one = {
        isLoading: true,
        data: null,
        error: null,
      };
    },
    setQuestionSuccess: (state, { payload }) => {
      state.one = {
        isLoading: false,
        data: payload,
        error: null,
      };
    },
    setQuestionFailure: (state, { payload }) => {
      state.one = {
        isLoading: false,
        data: null,
        error: payload.message,
      };
    },
    setQuestionDefault: (state) => {
      state.one = {
        isLoading: false,
        data: null,
        error: null,
      };
    },

    //Categories
    setQuestionCategoriesRequest: (state) => {
      state.categories = {
        isLoading: true,
        hits: null,
        error: null,
      };
    },
    setQuestionCategoriesSuccess: (state, { payload }) => {
      state.categories = {
        isLoading: false,
        hits: payload,
        error: null,
      };
    },
    setQuestionCategoriesFailure: (state, { payload }) => {
      state.categories = {
        isLoading: false,
        hits: null,
        error: payload.message,
      };
    },
    setQuestionCategoriesDefault: (state) => {
      state.categories = {
        isLoading: false,
        hits: null,
        error: null,
      };
    },

    //Difficulty levels
    setQuestionDifficultyLevelsRequest: (state) => {
      state.difficultyLevels = {
        isLoading: true,
        hits: null,
        error: null,
      };
    },
    setQuestionDifficultyLevelsSuccess: (state, { payload }) => {
      state.difficultyLevels = {
        isLoading: false,
        hits: payload,
        error: null,
      };
    },
    setQuestionDifficultyLevelsFailure: (state, { payload }) => {
      state.difficultyLevels = {
        isLoading: false,
        hits: null,
        error: payload.message,
      };
    },
    setQuestionDifficultyLevelsDefault: (state) => {
      state.difficultyLevels = {
        isLoading: false,
        hits: null,
        error: null,
      };
    },

    //Fields
    setQuestionFieldsRequest: (state) => {
      state.fields = {
        isLoading: true,
        hits: null,
        error: null,
      };
    },
    setQuestionFieldsSuccess: (state, { payload }) => {
      state.fields = {
        isLoading: false,
        hits: payload,
        error: null,
      };
    },
    setQuestionFieldsFailure: (state, { payload }) => {
      state.fields = {
        isLoading: false,
        hits: null,
        error: payload.message,
      };
    },
    setQuestionFieldsDefault: (state) => {
      state.fields = {
        isLoading: false,
        hits: null,
        error: null,
      };
    },
  },
});
